<template>
  <div
    v-if="show"
    :id="id"
    :class="alertClass"
    class="rounded-md p-4"
  >
    <div class="flex">
      <div class="shrink-0">
        <slot name="icon" />
      </div>
      <div class="ml-3">
        <p
          :class="descriptionClass"
          class="text-sm font-medium"
        >
          <slot name="message" />
        </p>
      </div>
      <div class="ml-auto pl-3">
        <div class="-mx-1.5 -my-1.5">
          <button
            type="button"
            :class="buttonClass"
            class="inline-flex rounded-md p-1.5 focus:ring-2 focus:ring-offset-2 focus:outline-hidden"
            @click="$emit('close'), show = false"
          >
            <span class="sr-only">
              {{ trans.get("miliboo.common.close") }}
            </span>
            <XMarkIcon
              class="size-5"
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, nextTick } from 'vue';
import { XMarkIcon } from '@heroicons/vue/20/solid';
import { useDebounceFn } from '@vueuse/core';
import useScrollTo from '../../composables/useScrollTo';

const trans = inject('translate');

defineEmits(['close']);

const props = defineProps({
  alertClass: {
    type: String,
    required: true,
  },
  descriptionClass: {
    type: String,
    required: true,
  },
  buttonClass: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  open: {
    type: Boolean,
    default: true,
  },
});
const { scrollTo } = useScrollTo();

nextTick(() => useDebounceFn((e) => scrollTo(e), 120)(props.id));

const show = defineModel('open', { default: true, type: Boolean });

</script>
